import { pushDataLayerEvent } from "./index";

type CampaignActionType = {
  campaign_id: "gemcam_trade_in_20250327";
  action: "click:trade_in_ad" | "click:campaign_video" | "click:claim_trade_in_credit";
  placement: "camera" | "main_menu" | "camera_float";
  action_parameters?: object;
};

export const pushCampaignActionLayerEvent = (event_params: CampaignActionType) => {
  pushDataLayerEvent({ event: "gemhub:campaign:action", event_params });
};
